export const QUERY_STATUS = {
  NEW: "NEW",
  ASSIGNED: "ASSIGNED",
  CONTACTED: "CONTACTED",
  IN_DISCUSSION: "IN_DISCUSSION",
  OFFER_SENT: "OFFER_SENT",
  CONVERTED: "CONVERTED",
  CLOSED: "CLOSED",
  CANCELLED: "CANCELLED",
};

export const QUERY_STATUS_VALUES =
  Object.values(QUERY_STATUS);


export const QUERY_STATUS_LABELS = {
  [QUERY_STATUS.NEW]: "New",
  [QUERY_STATUS.ASSIGNED]: "Assigned",
  [QUERY_STATUS.CONTACTED]: "Contacted",
  [QUERY_STATUS.IN_DISCUSSION]: "In Discussion",
  [QUERY_STATUS.OFFER_SENT]: "Offer Sent",
  [QUERY_STATUS.CONVERTED]: "Converted",
  [QUERY_STATUS.CLOSED]: "Closed",
  [QUERY_STATUS.CANCELLED]: "Cancelled",
};


export const DEFAULT_QUERY_PAGE = 1;

export const DEFAULT_QUERY_LIMIT = 20;

export const QUERY_LIMIT_OPTIONS = [
  10,
  20,
  50,
  100,
];